const productData = [
  {
    id: 1,
    name: "Twin Heart Color-Stone Ring",
    category: "Rings",
    price: "189.00",
    image: "/generated-products/p01-01.jpg",
    images: ["/generated-products/p01-01.jpg", "/generated-products/p01-02.jpg", "/generated-products/p01-03.jpg", "/generated-products/p01-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "10K White Gold", "10K Yellow Gold", "10K Rose Gold"],
    material: "Premium 925 Sterling Silver",
    birthstones: ["Garnet", "Amethyst", "Aquamarine", "Diamond", "Emerald", "Pearl", "Ruby", "Peridot", "Sapphire", "Opal", "Topaz", "Turquoise"],
    description: [
      "Two heart-shaped stones meet in a balanced design created for color and contrast.",
      "This exquisite ring features two elegantly crafted heart settings, each holding a brilliant birthstone of your choice.",
      "Perfect for representing the bond between you and a loved one, whether it's for a partner, child, parent, or dear friend.",
      "Each heart is meticulously designed to cradle its birthstone securely while allowing maximum light exposure for exceptional sparkle.",
      "The band is delicately crafted with a comfortable fit that you'll love wearing every day.",
      "Available in your choice of precious metals to perfectly match your personal style and skin tone.",
      "This ring makes a thoughtful gift for anniversaries, birthdays, Mother's Day, Valentine's Day, or any special occasion worth celebrating.",
      "Review the listed material, size, and care details before ordering."
    ],
    Features: [
      "Two heart-shaped birthstone settings for personalized meaning",
      "A range of color-stone options",
      "Available in Sterling Silver, 10K White, Yellow, or Rose Gold",
      "Comfort-fit band design for all-day wear",
      "Secure prong setting to protect your gemstones",
      "Hand-polished to a brilliant, mirror-like finish",
      "Comes in a beautiful gift box ready for presenting",
      "Return eligibility depends on the selected options",
      "Order support available by email",
      "Free insured shipping on all orders"
    ]
  },
  {
    id: 2,
    name: "Crossing Duo Stone Ring",
    category: "Rings",
    price: "155.00",
    image: "/generated-products/p02-01.jpg",
    images: ["/generated-products/p02-01.jpg", "/generated-products/p02-02.jpg", "/generated-products/p02-03.jpg", "/generated-products/p02-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "14K Gold Plated", "Rose Gold Plated"],
    material: "925 Sterling Silver with premium plating",
    birthstones: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    description: [
      "A crossing band brings two round color stones into a clean, open composition.",
      "The bypass design creates a modern, flowing silhouette that wraps around your finger with grace and style.",
      "This ring is perfect for representing two special people or significant moments in your life.",
      "Whether you choose birthstones for children, partners, parents, or friends, this piece tells your unique story.",
      "The stones are set in a way that allows them to sparkle brilliantly from every angle, catching light with every movement.",
      "Crafted with meticulous attention to detail, this ring is designed to be both beautiful and comfortable for everyday wear.",
      "The bypass design also makes this ring surprisingly versatile, working beautifully with both casual and formal attire.",
      "Each piece is carefully inspected to ensure it meets our high standards of quality and craftsmanship before it reaches you."
    ],
    Features: [
      "Elegant bypass design with two birthstone accents",
      "Smooth, comfortable band for extended wear",
      "Secure bezel or prong setting options",
      "Choice of 12 stunning birthstones",
      "Multiple finish options",
      "Available in multiple metal finishes",
      "Perfect for stacking with other rings",
      "Comes with a detailed care and cleaning guide",
      "Sizing options are listed on the product page",
      "Care instructions available on request"
    ]
  },
  {
    id: 3,
    name: "Four-Stone Sculpted Twist Ring",
    category: "Rings",
    price: "214.00",
    image: "/generated-products/p03-01.jpg",
    images: ["/generated-products/p03-01.jpg", "/generated-products/p03-02.jpg", "/generated-products/p03-03.jpg", "/generated-products/p03-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "10K Gold", "14K Gold"],
    material: "Metal options as selected",
    birthstones: ["Ruby", "Sapphire", "Emerald", "Diamond", "Amethyst", "Topaz", "Garnet", "Peridot"],
    description: [
      "Four color stones punctuate a softly sculpted band with a rhythmic twist.",
      "This distinctive ring showcases four beautiful birthstones, making it perfect for celebrating a family of four or four special people in your life.",
      "The twisted, textured band creates fascinating light reflections that dance across the surface with every movement of your hand.",
      "Each birthstone is carefully set to complement the ring's unique design, creating a harmonious balance between color and texture.",
      "This piece makes an exceptional gift for mothers, grandmothers, or anyone who cherishes their family connections.",
      "The flat profile of the band ensures comfortable everyday wear and easy stacking with other favorite rings.",
      "The intricate twisting pattern adds depth and visual interest, making this ring a true conversation starter.",
      "Its textured profile gives the design a distinctive finish from every angle."
    ],
    Features: [
      "Unique twisted croissant texture for visual interest",
      "Four birthstone settings for personalization",
      "Flat, comfortable band design",
      "Excellent for stacking with other rings",
      "Material options shown above",
      "Available in multiple karat options",
      "Textured finish hides minor scratches",
      "Perfect for family or friend groups of four",
      "Comes in an elegant velvet gift box",
      "Order support available by email"
    ]
  },
  {
    id: 4,
    name: "Four-Petal Marquise Accent Ring",
    category: "Rings",
    price: "239.00",
    image: "/generated-products/p04-01.jpg",
    images: ["/generated-products/p04-01.jpg", "/generated-products/p04-02.jpg", "/generated-products/p04-03.jpg", "/generated-products/p04-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Platinum Plated", "18K Gold Plated", "Rose Gold Plated"],
    material: "Sterling Silver with thick premium plating",
    birthstones: ["Diamond Simulants", "Genuine Gemstones", "Lab-Created Stones"],
    description: [
      "Four marquise-shaped stones form a petal-like arrangement with small round accents.",
      "The marquise-cut birthstones create an elongated, flattering effect on the finger while showcasing each stone's unique color.",
      "Four beautiful marquise stones are perfectly complemented by sparkling round accents that add extra dimension and fire.",
      "This sophisticated design is perfect for special occasions yet versatile enough for everyday wear.",
      "The marquise shape has a rich history, originally commissioned by King Louis XV of France to resemble the lips of his mistress.",
      "Each stone is expertly cut and polished to maximize brilliance and display its natural beauty to full effect.",
      "This ring makes a stunning gift for someone special or a wonderful addition to your own jewelry collection.",
      "Our jewelers take great pride in creating pieces that combine exceptional quality with affordable luxury."
    ],
    Features: [
      "Four elegant marquise-cut birthstones",
      "Sparkling round accent stones for extra brilliance",
      "Classic and sophisticated design",
      "Prong setting for maximum light exposure",
      "Stone options vary by selection",
      "Thick premium plating for long-lasting wear",
      "Comfort-fit band design",
      "Perfect for anniversaries and special occasions",
      "Return eligibility depends on the selected options",
      "Care instructions available on request"
    ]
  },
  {
    id: 5,
    name: "Marquise Garden Bracelet",
    category: "Bracelets",
    price: "200.00",
    image: "/generated-products/p05-01.jpg",
    images: ["/generated-products/p05-01.jpg", "/generated-products/p05-02.jpg", "/generated-products/p05-03.jpg", "/generated-products/p05-04.jpg"],
    size: ["6.5 inches", "7 inches", "7.5 inches", "8 inches"],
    colors: ["Sterling Silver", "Gold Vermeil", "Rose Gold Vermeil"],
    material: "925 Sterling Silver with optional vermeil",
    birthstones: ["All 12 months available"],
    description: [
      "Marquise-shaped color stones sit among leaf-inspired details on a fine bracelet.",
      "Each leaf is intricately detailed, adding organic charm and graceful movement to this exceptional piece of jewelry.",
      "Four marquise birthstones are nestled among the leaves, representing loved ones or special moments with sparkling beauty.",
      "The bracelet's design is inspired by the beauty of nature, bringing a touch of the outdoors to your everyday style.",
      "Perfect for nature lovers, gardeners, or anyone who appreciates the delicate beauty of botanical-inspired jewelry.",
      "The adjustable chain ensures a perfect fit for most wrist sizes, making it a wonderful gift option.",
      "This bracelet looks stunning worn alone as a statement piece or layered with other bracelets for a bohemian-chic look.",
      "Each leaf is meticulously crafted and polished to bring out every detail of this nature-inspired design."
    ],
    Features: [
      "Beautiful botanical leaf design",
      "Four marquise-cut birthstones",
      "Adjustable chain for perfect fit",
      "Lightweight and comfortable for all-day wear",
      "Material details shown on the product page",
      "Secure lobster claw clasp",
      "Perfect for layering or wearing alone",
      "Comes with a polishing cloth for easy care",
      "Ideal gift for nature enthusiasts",
      "Order support available by email"
    ]
  },
  {
    id: 6,
    name: "Oval & Pear Duo Bracelet",
    category: "Bracelets",
    price: "149.00",
    image: "/generated-products/p06-01.jpg",
    images: ["/generated-products/p06-01.jpg", "/generated-products/p06-02.jpg", "/generated-products/p06-03.jpg", "/generated-products/p06-04.jpg"],
    size: ["Small", "Medium", "Large", "Extra Large"],
    colors: ["Silver", "Gold", "Rose Gold"],
    material: "Premium brass with high-quality plating",
    gemstones: ["Oval Cut", "Pear Cut", "Mixed Stones"],
    description: [
      "An oval stone and a pear-shaped stone create an intentionally asymmetric bracelet.",
      "This romantic design features an oval gemstone and a pear-shaped gemstone, symbolizing two distinct yet complementary souls.",
      "The contrasting cuts give each side of the design its own character.",
      "This bracelet perfectly captures the essence of partnership, love, and the beautiful journey shared by two people.",
      "The oval gemstone represents eternity and wholeness, while the pear shape symbolizes uniqueness and individuality.",
      "Whether for an engagement, anniversary, or just because, this bracelet tells a beautiful love story.",
      "The delicate chain is designed to showcase the gemstones beautifully while providing comfortable, secure wear.",
      "This piece is perfect for everyday wear or special occasions, adding romantic elegance to any outfit."
    ],
    Features: [
      "Two contrasting stone shapes",
      "One oval-cut and one pear-cut gemstone",
      "Delicate yet durable chain",
      "Symbolic representation of partnership",
      "Available in three beautiful finishes",
      "Comfortable for extended wear",
      "Secure clasp for peace of mind",
      "Perfect for engagements and anniversaries",
      "Comes in a romantic gift box",
      "Order support available by email"
    ]
  },
  {
    id: 7,
    name: "Single Letter Pendant",
    category: "Necklaces",
    price: "124.00",
    image: "/generated-products/p07-01.jpg",
    images: ["/generated-products/p07-01.jpg", "/generated-products/p07-02.jpg", "/generated-products/p07-03.jpg", "/generated-products/p07-04.jpg"],
    size: ["16 inches", "18 inches", "20 inches", "22 inches"],
    colors: ["Sterling Silver", "18K Gold Plated", "Rose Gold Plated"],
    material: "925 Sterling Silver base",
    letters: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
    description: [
      "A single letter pendant gives this necklace a simple personal focus.",
      "Wear your own initial, the initial of a loved one, or create a layered look with multiple initials for a truly personal statement.",
      "Each letter is meticulously designed with beautiful proportions and elegant curves that catch the light beautifully.",
      "This classic piece is perfect for everyday wear, adding a touch of personal elegance to any outfit.",
      "Makes a thoughtful gift for birthdays, graduations, new moms, bridesmaids, or anyone celebrating a new beginning.",
      "The delicate chain allows the initial to take center stage while providing comfortable, worry-free wear.",
      "Available in multiple finishes to perfectly match your personal style and existing jewelry collection.",
      "This timeless piece will become a cherished favorite that you'll reach for again and again."
    ],
    Features: [
      "Beautifully crafted single initial pendant",
      "All 26 letters of the alphabet available",
      "Classic, timeless design",
      "Multiple chain length options",
      "Choice of three beautiful finishes",
      "Perfect for layering with other necklaces",
      "Lightweight and comfortable",
      "Comes in a beautiful gift box",
      "Ideal for personalized gifting",
      "Order support available by email"
    ]
  },
  {
    id: 8,
    name: "Sideways Heart & Color-Stone Necklace",
    category: "Necklaces",
    price: "108.00",
    image: "/generated-products/p08-01.jpg",
    images: ["/generated-products/p08-01.jpg", "/generated-products/p08-02.jpg", "/generated-products/p08-03.jpg", "/generated-products/p08-04.jpg"],
    size: ["14 inches", "16 inches", "18 inches", "20 inches"],
    colors: ["Sterling Silver", "Gold", "Rose Gold"],
    material: "Premium 925 Sterling Silver",
    birthstones: ["All months available"],
    engravable: true,
    description: [
      "A sideways heart and a small color stone sit along a delicate necklace chain.",
      "The heart is positioned sideways, creating a modern and flattering silhouette that lies beautifully against the skin.",
      "Add a sparkling birthstone for an extra personal touch that celebrates a special person or meaningful date.",
      "The engravable surface allows you to add initials, a date, a short name, or a meaningful word that holds special significance.",
      "Perfect for everyday wear, this necklace adds a subtle touch of romance and personal meaning to any outfit.",
      "Makes a beautiful gift for Valentine's Day, anniversaries, birthdays, or just to show someone how much you care.",
      "The delicate chain is designed to complement the heart pendant perfectly, creating a harmonious and elegant look.",
      "This piece is designed to be treasured for years, carrying your special message close to your heart always."
    ],
    Features: [
      "Sideways heart pendant for modern style",
      "Engravable surface for personal messages",
      "Accent birthstone for extra meaning",
      "Perfect for everyday wear",
      "Multiple chain lengths available",
      "Material details shown on the product page",
      "Comfortable and lightweight",
      "Comes with engraving options",
      "Beautiful romantic gift",
      "Return eligibility depends on the selected options"
    ]
  },
  {
    id: 9,
    name: "Curved Twin Bezel Ring",
    category: "Rings",
    price: "209.00",
    image: "/generated-products/p09-01.jpg",
    images: ["/generated-products/p09-01.jpg", "/generated-products/p09-02.jpg", "/generated-products/p09-03.jpg", "/generated-products/p09-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "10K White Gold", "10K Yellow Gold"],
    material: "Premium metals with excellent craftsmanship",
    birthstones: ["Choice of any two birthstones"],
    description: [
      "Two bezel-set round stones follow the line of a gently curved band.",
      "The bezel setting provides exceptional protection for your gemstones while creating a sleek, modern aesthetic.",
      "Two round birthstones sit beautifully in their individual bezels, representing two special people or moments in your life.",
      "The gently curved band creates a comfortable, ergonomic fit that feels wonderful on your finger.",
      "This design is perfect for stacking with other rings, creating beautiful and unique combinations.",
      "The bezel setting also gives the stones a larger appearance while keeping them securely in place.",
      "Whether representing a partnership, siblings, parent and child, or dear friends, this ring tells a beautiful story.",
      "Each piece is carefully crafted to ensure the stones are perfectly set and the band is beautifully finished."
    ],
    Features: [
      "Elegant curved band design",
      "Two bezel-set round birthstones",
      "Secure bezel setting for gem protection",
      "Modern, sleek aesthetic",
      "Comfortable ergonomic fit",
      "Excellent for stacking",
      "Choice of premium metals",
      "Perfect for representing two people",
      "Comes with a jewelry care guide",
      "Order support available by email"
    ]
  },
  {
    id: 10,
    name: "Marquise Quartet Ring",
    category: "Rings",
    price: "179.00",
    image: "/generated-products/p10-01.jpg",
    images: ["/generated-products/p10-01.jpg", "/generated-products/p10-02.jpg", "/generated-products/p10-03.jpg", "/generated-products/p10-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "14K Gold", "14K Rose Gold"],
    material: "High-quality precious metals",
    stones: ["Four marquise-cut stones"],
    description: [
      "Four marquise-shaped stones align across a slender band for a graphic silhouette.",
      "The elongated marquise shape creates a flattering, slimming effect on the finger while maximizing the visual impact of each stone.",
      "Four stones can represent family members, children, siblings, or any four people or moments you hold dear.",
      "The symmetrical arrangement creates balance and harmony, making this ring both visually striking and deeply meaningful.",
      "Each marquise stone is carefully selected and set to display its unique color and brilliance to full effect.",
      "This ring commands attention whether worn alone as a statement piece or paired with other complementary jewelry.",
      "The substantial yet comfortable band provides a perfect foundation for this spectacular design.",
      "The repeated pointed shapes give the ring a crisp, directional look."
    ],
    Features: [
      "Four stunning marquise-cut stones",
      "Elegant symmetrical arrangement",
      "Flattering, finger-lengthening effect",
      "Substantial yet comfortable band",
      "Perfect for family of four",
      "Exceptional brilliance and fire",
      "Available in multiple metal options",
      "Expertly hand-set stones",
      "Comes in a luxury gift box",
      "Shipping and return details available before checkout"
    ]
  },
  {
    id: 11,
    name: "Heart & Pear V-Band Ring",
    category: "Rings",
    price: "179.00",
    image: "/generated-products/p11-01.jpg",
    images: ["/generated-products/p11-01.jpg", "/generated-products/p11-02.jpg", "/generated-products/p11-03.jpg", "/generated-products/p11-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "Gold Plated", "Rose Gold Plated"],
    material: "925 Sterling Silver",
    stones: ["Heart-cut", "Pear-cut"],
    description: [
      "A heart-shaped stone and pear-shaped stone meet above an angular V band.",
      "Meaning 'You and Me,' this design celebrates the beautiful union of two distinct individuals coming together in love.",
      "The heart shape represents love, romance, and devotion, while the pear shape symbolizes uniqueness and individuality.",
      "The V-shape band creates a modern, flattering silhouette that elegantly frames the two gemstones.",
      "This design is rich in symbolism, perfect for engagements, anniversaries, or celebrating any loving partnership.",
      "The V-shape also makes this ring perfect for stacking with wedding bands or other rings in your collection.",
      "Each stone is carefully selected for its beauty and brilliance, creating a harmonious and eye-catching combination.",
      "This ring is more than jewelry—it's a beautiful symbol of your unique love story."
    ],
    Features: [
      "Contrasting heart and pear shapes",
      "One heart-cut and one pear-cut gemstone",
      "Elegant V-shape band",
      "Perfect for engagements",
      "Rich in romantic symbolism",
      "Excellent for stacking",
      "Modern and flattering silhouette",
      "Material details shown on the product page",
      "Comes in romantic packaging",
      "Order support available by email"
    ]
  },
  {
    id: 12,
    name: "Offset Hearts Curve Ring",
    category: "Rings",
    price: "184.00",
    image: "/generated-products/p12-01.jpg",
    images: ["/generated-products/p12-01.jpg", "/generated-products/p12-02.jpg", "/generated-products/p12-03.jpg", "/generated-products/p12-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "10K Gold", "10K Rose Gold"],
    material: "Premium quality metals",
    stones: ["Two heart gemstones"],
    description: [
      "Two tilted heart-shaped stones follow the sweep of a curved band.",
      "The tilted arrangement creates a dynamic, modern look that adds movement and personality to this romantic design.",
      "Two heart gemstones represent two hearts coming together, making this perfect for couples, mothers and children, or dear friends.",
      "The curved band wraps gracefully around the finger, providing exceptional comfort while adding visual interest.",
      "This whimsical yet sophisticated design is perfect for someone who appreciates romance with a contemporary twist.",
      "Each heart can be customized with a birthstone, adding personal meaning and beautiful color to the piece.",
      "The playful tilt gives the ring a lighthearted feeling while still maintaining elegance and quality.",
      "The offset setting gives the design movement without visual weight."
    ],
    Features: [
      "Two tilted heart gemstones",
      "Dynamic, modern design",
      "Elegant curved band",
      "Playful yet sophisticated",
      "Perfect for couples",
      "Comfortable for everyday wear",
      "Choice of birthstones",
      "Whimsical romantic aesthetic",
      "Excellent gift for loved ones",
      "Return eligibility depends on the selected options"
    ]
  },
  {
    id: 13,
    name: "Oval & Pear Mismatched Studs",
    category: "Earrings",
    price: "124.00",
    image: "/generated-products/p13-01.jpg",
    images: ["/generated-products/p13-01.jpg", "/generated-products/p13-02.jpg", "/generated-products/p13-03.jpg", "/generated-products/p13-04.jpg"],
    size: ["One Size"],
    colors: ["Sterling Silver", "14K Gold Plated", "Rose Gold Plated"],
    material: "925 Sterling Silver with secure posts",
    stones: ["Oval-cut", "Pear-cut"],
    description: [
      "One oval and one pear-shaped stone create a deliberately mismatched pair of studs.",
      "Each earring features both an oval-cut and a pear-cut gemstone, creating a beautiful asymmetry that catches the eye.",
      "The oval represents wholeness and eternity, while the pear symbolizes uniqueness, together creating perfect balance.",
      "These studs are designed to be noticeable yet not overwhelming, perfect for both casual and formal occasions.",
      "The secure post backing ensures these earrings stay comfortably in place all day and night.",
      "Perfect for everyday wear, these earrings add a touch of romantic elegance to any outfit.",
      "The classic stud design with a twist makes these earrings a versatile addition to any jewelry collection.",
      "Each pair is carefully crafted to ensure the stones are perfectly matched and beautifully set."
    ],
    Features: [
      "Two complementary stone shapes",
      "One oval and one pear-cut stone per earring",
      "Versatile stud style",
      "Perfect for everyday wear",
      "Secure post backings",
      "Material details shown on the product page",
      "Classic with a modern twist",
      "Comfortable for all-day wear",
      "Comes as a matching pair",
      "Beautiful gift option"
    ]
  },
  {
    id: 14,
    name: "Marquise & Bar Mismatched Studs",
    category: "Earrings",
    price: "124.00",
    image: "/generated-products/p14-01.jpg",
    images: ["/generated-products/p14-01.jpg", "/generated-products/p14-02.jpg", "/generated-products/p14-03.jpg", "/generated-products/p14-04.jpg"],
    size: ["One Size"],
    colors: ["Sterling Silver", "Gold", "Rose Gold"],
    material: "Premium 925 Sterling Silver",
    stones: ["Marquise-cut", "Baguette-cut"],
    description: [
      "A marquise-shaped stone and a slim bar stone form a geometric mismatched pair.",
      "The elongated marquise cut adds romance and softness, while the geometric baguette brings modern sophistication.",
      "This Art Deco-inspired combination creates a striking look that's both timeless and contemporary.",
      "Each earring showcases both cuts, creating beautiful asymmetry and visual interest from every angle.",
      "These studs make a sophisticated statement without being overpowering, perfect for day or evening wear.",
      "The secure post design ensures comfortable, worry-free wear throughout your busy day.",
      "Perfect for adding a touch of vintage glamour to your everyday look or completing an elegant evening ensemble.",
      "Each pair is meticulously crafted to ensure perfect alignment and brilliant sparkle from both stones."
    ],
    Features: [
      "Stunning marquise and baguette combination",
      "Art Deco-inspired design",
      "Timeless yet contemporary",
      "Perfect for day or evening",
      "Secure post backings",
      "Material details shown on the product page",
      "Vintage glamour aesthetic",
      "Comfortable all-day wear",
      "Beautiful matching pair",
      "Order support available by email"
    ]
  },
  {
    id: 15,
    name: "Heart Center Accent Ring",
    category: "Rings",
    price: "179.00",
    image: "/generated-products/p15-01.jpg",
    images: ["/generated-products/p15-01.jpg", "/generated-products/p15-02.jpg", "/generated-products/p15-03.jpg", "/generated-products/p15-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "14K White Gold", "14K Yellow Gold", "14K Rose Gold"],
    material: "Premium precious metals",
    centerStone: ["Heart-cut gemstone"],
    accentStones: ["Side accent stones"],
    description: [
      "A heart-shaped center stone is framed by small accents along the band.",
      "The heart-shaped center stone takes pride of place, symbolizing love, romance, and deep affection.",
      "Sparkling side accent stones frame the heart perfectly, adding extra sparkle and enhancing the center stone's beauty.",
      "This classic yet romantic design is perfect for engagements, anniversaries, Valentine's Day, or any romantic occasion.",
      "The solitaire style ensures the heart remains the focal point, while the accents add just the right amount of extra sparkle.",
      "Whether given as a promise ring, engagement ring, or anniversary gift, this piece speaks directly from the heart.",
      "The elegant band is designed to showcase the stones beautifully while providing comfort and durability for everyday wear.",
      "The side details draw attention toward the center without overwhelming it."
    ],
    Features: [
      "Beautiful heart-shaped center stone",
      "Sparkling side accent stones",
      "Classic solitaire design",
      "Perfect for romantic occasions",
      "Excellent as an engagement ring",
      "Symbolizes love and romance",
      "Choice of premium metals",
      "Comfortable everyday wear",
      "Comes in romantic gift packaging",
      "Return eligibility depends on the selected options"
    ]
  },
  {
    id: 16,
    name: "Twin Hearts Wave Ring",
    category: "Rings",
    price: "195.00",
    image: "/generated-products/p16-01.jpg",
    images: ["/generated-products/p16-01.jpg", "/generated-products/p16-02.jpg", "/generated-products/p16-03.jpg", "/generated-products/p16-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "10K Gold", "Rose Gold"],
    material: "High-quality 925 Sterling Silver",
    stones: ["Two heart birthstones"],
    description: [
      "Two heart-shaped color stones sit within the flowing line of a wave band.",
      "The wave design represents the journey of life, with its beautiful rhythms and flowing moments shared with loved ones.",
      "Two heart birthstones represent two special people whose lives are connected through the beautiful journey of life.",
      "The undulating wave pattern creates a comfortable, organic feel that wraps gracefully around your finger.",
      "This design is perfect for representing a partnership, mother and child, siblings, or any two deeply connected people.",
      "The wave design also creates fascinating light play, with different facets catching the light as your hand moves.",
      "Comfortable enough for everyday wear yet special enough for meaningful occasions, this ring is versatile and beautiful.",
      "Each piece is carefully crafted to ensure the wave flows naturally and the hearts are perfectly positioned."
    ],
    Features: [
      "Beautiful wave-inspired design",
      "Two heart-shaped birthstones",
      "Symbolizes life's journey together",
      "Organic, flowing aesthetic",
      "Comfortable for everyday wear",
      "Perfect for couples or family",
      "Fascinating light play",
      "Meaningful and versatile",
      "Comes in a beautiful gift box",
      "Order support available by email"
    ]
  },
  {
    id: 17,
    name: "Heart Center Message Band",
    category: "Rings",
    price: "169.00",
    image: "/generated-products/p17-01.jpg",
    images: ["/generated-products/p17-01.jpg", "/generated-products/p17-02.jpg", "/generated-products/p17-03.jpg", "/generated-products/p17-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "14K Gold", "14K Rose Gold"],
    material: "Premium 925 Sterling Silver or Gold",
    centerStone: ["Heart-cut center stone"],
    engravable: true,
    description: [
      "A heart-shaped center stone meets a broad band designed for a short personal message.",
      "The stunning heart-shaped center stone is the focal point, symbolizing love, commitment, and deep affection.",
      "The engravable band allows you to add initials, a date, a short phrase, or coordinates that hold special meaning for you.",
      "This ring is perfect for engagements, anniversaries, promise rings, or any occasion where you want to express your love.",
      "The classic solitaire setting ensures the heart stone is displayed prominently, showing off its brilliance and beauty.",
      "Your personal engraving adds an extra layer of meaning, making this ring truly one-of-a-kind and deeply personal.",
      "Comfortable enough for everyday wear, this ring is designed to be treasured and worn with love for years to come.",
      "Check the entered message carefully before adding the item to your cart."
    ],
    Features: [
      "Beautiful heart solitaire center stone",
      "Fully engravable band",
      "Perfect for personal messages",
      "Classic and timeless design",
      "Ideal for engagements",
      "Comfortable everyday wear",
      "Truly one-of-a-kind",
      "Choice of premium metals",
      "Comes with engraving service",
      "Return eligibility depends on the selected options"
    ]
  },
  {
    id: 18,
    name: "Heart Center Tapered Ring",
    category: "Rings",
    price: "149.00",
    image: "/generated-products/p18-01.jpg",
    images: ["/generated-products/p18-01.jpg", "/generated-products/p18-02.jpg", "/generated-products/p18-03.jpg", "/generated-products/p18-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "10K Gold", "10K Rose Gold"],
    material: "High-quality precious metals",
    centerStone: ["Heart-cut gemstone"],
    description: [
      "A heart-shaped center stone rises from a wide band that narrows toward the back.",
      "The tapered wide band provides a substantial, comfortable feel while elegantly framing the heart stone and drawing the eye toward it.",
      "The band gradually narrows toward the top, creating a flattering silhouette that makes the heart appear even more prominent and brilliant.",
      "This design has a modern, architectural feel while still maintaining timeless romance and elegance.",
      "The substantial band gives the ring presence and makes it perfect for wearing alone as a statement piece.",
      "The wide band also provides excellent stability and comfort, making this ring feel wonderful on your finger.",
      "Whether for everyday wear or special occasions, this ring balances boldness with delicate romance beautifully.",
      "Each piece is carefully crafted to ensure the proportions are perfect and the heart is securely and beautifully set."
    ],
    Features: [
      "Stunning heart solitaire",
      "Elegant tapered wide band",
      "Modern, substantial feel",
      "Flattering silhouette",
      "Perfect as a statement piece",
      "Excellent comfort and stability",
      "Bold yet romantic",
      "Choice of precious metals",
      "Comfortable for extended wear",
      "Order support available by email"
    ]
  },
  {
    id: 19,
    name: "Oval & Pear Wide-Band Ring",
    category: "Rings",
    price: "159.00",
    image: "/generated-products/p19-01.jpg",
    images: ["/generated-products/p19-01.jpg", "/generated-products/p19-02.jpg", "/generated-products/p19-03.jpg", "/generated-products/p19-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "14K Gold", "14K Rose Gold"],
    material: "Premium quality materials",
    stones: ["Oval-cut", "Pear-cut"],
    description: [
      "Oval and pear-shaped stones face across a polished wide band.",
      "The 'You and Me' design features an oval and a pear-cut stone, representing two unique individuals coming together in harmony.",
      "The oval shape symbolizes eternity and wholeness, while the pear represents individuality and unique beauty.",
      "The wide band provides a bold, contemporary foundation that beautifully contrasts with the delicate gemstones.",
      "This substantial band gives the ring a modern, confident feel while still maintaining romantic elegance.",
      "Perfect for someone who appreciates bold design with romantic symbolism, this ring makes a powerful statement.",
      "The wide band also ensures exceptional comfort and stability, making this ring a joy to wear.",
      "Each piece is carefully crafted to ensure both stones are beautifully showcased and perfectly balanced on the band."
    ],
    Features: [
      "Contrasting oval and pear shapes",
      "Oval and pear-cut gemstones",
      "Substantial wide band",
      "Bold contemporary style",
      "Modern yet romantic",
      "Exceptional comfort",
      "Perfect for statement wear",
      "Choice of premium metals",
      "Beautifully balanced design",
      "Shipping and return details available before checkout"
    ]
  },
  {
    id: 20,
    name: "Pear Duo Curved-Band Ring",
    category: "Rings",
    price: "169.00",
    image: "/generated-products/p20-01.jpg",
    images: ["/generated-products/p20-01.jpg", "/generated-products/p20-02.jpg", "/generated-products/p20-03.jpg", "/generated-products/p20-04.jpg"],
    size: ["4", "5", "6", "7", "8", "9", "10", "11", "12"],
    colors: ["Sterling Silver", "10K Gold", "10K Rose Gold"],
    material: "925 Sterling Silver or Gold",
    stones: ["Two pear-cut gemstones"],
    description: [
      "Two pear-shaped stones follow opposite ends of a broad curved band.",
      "Two pear-shaped gemstones represent two individuals, each with their own unique beauty and orientation.",
      "The 'You and Me' concept celebrates partnership, with both stones complementing each other beautifully.",
      "The wide curved band provides exceptional comfort while creating an elegant, organic silhouette.",
      "The curve of the band follows the natural contour of your finger, making this ring feel like it was made just for you.",
      "Pear-cut stones are known for their unique shape that combines the brilliance of a round with the elegance of a marquise.",
      "This design is perfect for engagements, anniversaries, or celebrating any beautiful partnership.",
      "Each ring is carefully crafted to ensure the two pears are perfectly balanced and the band curves beautifully."
    ],
    Features: [
      "Two beautiful pear-cut gemstones",
      "Mirrored pear-shaped stones",
      "Wide curved band for comfort",
      "Organic, elegant silhouette",
      "Perfect for engagements",
      "Exceptionally comfortable",
      "Celebrates partnership",
      "Choice of metals",
      "Beautifully balanced",
      "Return eligibility depends on the selected options"
    ]
  }
];

export default productData;
